import clsx from 'clsx';
import { FC } from 'react';

import { useTranslation } from 'react-i18next';

import { LazyLoadImage } from 'react-lazy-load-image-component';

import styles from './error-page.module.scss';
import { IErrorPageProps } from './types';

import { Button, ETitleLevel, Title } from '../../components/ui';
import notGoundImg from '../../images/404.svg';

import { useReturn } from '~utils';

export const ErrorPage: FC<IErrorPageProps> = ({ className = '', ...rest }) => {
  const { t } = useTranslation();

  const { handleReturnClick } = useReturn();

  return (
    <div className={clsx(styles.container, className)} {...rest}>
      <LazyLoadImage className={styles.img} src={notGoundImg} alt={t('alts.not-found') || ''} />
      <Title className={styles.title} level={ETitleLevel.h4}>
        {t('error-page.title')}
      </Title>
      <Button text={t('error-page.back')} onClick={handleReturnClick} />
    </div>
  );
};
